import React, { useEffect, useState } from 'react';
import { PrimaryBtn } from '@panel/commons/lib/Button';

import { useTranslation } from 'react-i18next';
import { CenteredText, ContainerNivel, HelpText, ImgContainer, Title, SubtTitle } from './styles';

import IconDonwReputation from '../../assets/img/erro_reputacion.svg';

const PublisherErrorSection = ({ device, reloadDispatch }) => {
  const { t } = useTranslation();
  return (
    <ContainerNivel>
      <ImgContainer>
        <img src={IconDonwReputation} alt='Error de reputación' />
      </ImgContainer>
      <CenteredText>
        <Title style={{ width: device === 'desktop' ? '326px' : '' }}>{t('panel.reputacion.error.title')}</Title>
        <SubtTitle style={{ width: device === 'desktop' ? '326px' : '' }}>
          {t('panel.reputacion.error.subtitle')}
        </SubtTitle>
        <PrimaryBtn type='button' onClick={() => reloadDispatch()}>
          {t('panel.reconfirmation.error.CTA')}
        </PrimaryBtn>
      </CenteredText>
    </ContainerNivel>
  );
};

export default PublisherErrorSection;
